var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTableSortDesc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.4 0c.21 0 .387.07.53.212a.71.71 0 0 1 .213.525v8.777l1.412-1.4a.708.708 0 0 1 .52-.202.695.695 0 0 1 .725.718c0 .209-.068.38-.204.515L3.92 11.797a.652.652 0 0 1-.241.157A.83.83 0 0 1 3.4 12a.83.83 0 0 1-.279-.046.652.652 0 0 1-.241-.157L.204 9.145A.695.695 0 0 1 0 8.63a.695.695 0 0 1 .725-.718c.21 0 .384.067.52.202l1.412 1.4V.737A.71.71 0 0 1 2.87.212.722.722 0 0 1 3.4 0zm4 0a.7.7 0 0 1 .7.7v5a.7.7 0 0 1-.7.7h-.1a.7.7 0 0 1-.7-.7v-5a.7.7 0 0 1 .7-.7h.1zm3.8 0h.1a.7.7 0 0 1 .7.7v2.6a.7.7 0 0 1-.7.7h-.1a.7.7 0 0 1-.7-.7V.7a.7.7 0 0 1 .7-.7z",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableSortDesc);
export default __webpack_public_path__ + "static/media/table-sort-desc.f0a442e2fbccdcbdb43e88d30da182b8.svg";
export { ForwardRef as ReactComponent };